import PreviousPatient from './PreviousPatient.jsx'
import PreviousPatientCardio from './PreviousPatientCardio.jsx'
import PreviousPatientConnector from './PreviousPatientConnector.jsx'
import PreviousPatientCardioConnector from './PreviousPatientCardioConnector.jsx'

export { PreviousPatient, PreviousPatientCardio, PreviousPatientCardioConnector, PreviousPatientConnector }
